module.exports = __webpack_public_path__ + "static/media/Winning sales.6630b04f.pdf";